export default "__VITE_ASSET__oFx4U3Gb__"